import { PublicLayout } from "@/components/public/public-layout";
import { InvestorPortalBand } from "@/components/public/investor-portal-band";
import { Container, Section, PageHero } from "@/components/public/institutional-ui";
import { ContactInquiryForm } from "@/components/public/contact-inquiry-form";
import { FadeIn } from "@/components/ui/scroll-animations";
import { Mail, MapPin, Clock } from "lucide-react";

const details = [
  { icon: Mail, label: "Email", value: "support@godmancapital.in", href: "mailto:support@godmancapital.in" },
  {
    icon: MapPin,
    label: "Office",
    value: "11th Floor, Raheja Tower, MG Road, Bangalore – 560001",
    href: null,
  },
  {
    icon: Clock,
    label: "Hours",
    value: "Mon – Fri: 9:00 AM – 6:00 PM IST",
    href: null,
  },
];

export default function ContactPage() {
  return (
    <PublicLayout>
      <PageHero
        eyebrow="Contact"
        title="Start a conversation"
        description="Whether you're exploring capital solutions or looking to partner with us—our institutional desk is ready to engage."
      />

      <Section className="!pt-0">
        <Container>
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
            <FadeIn>
              <p className="gc-eyebrow text-muted-foreground mb-8">Direct access</p>
              <div className="space-y-8">
                {details.map((item) => (
                  <div key={item.label} className="flex gap-4">
                    <item.icon className="w-5 h-5 text-foreground/40 shrink-0 mt-0.5" strokeWidth={1.25} />
                    <div>
                      <p className="gc-field-label mb-1">{item.label}</p>
                      {item.href ? (
                        <a href={item.href} className="hover:opacity-60 transition-opacity">
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-muted-foreground">{item.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </FadeIn>
            <FadeIn delay={0.1}>
              <div className="border border-border p-8 md:p-10 bg-[hsl(var(--surface))]">
                <ContactInquiryForm source="contact-page" />
              </div>
            </FadeIn>
          </div>
        </Container>
      </Section>

      <InvestorPortalBand />
    </PublicLayout>
  );
}
